import Kpi from "@/models/Kpi";

export default class {
  content = [];
  totalElements = 0;
  totalPages = 0;

  constructor (data = {}) {
    for (let key in this) {
      if (data[key] !== undefined) {
        if (data[key] !== null && data[key] !== 'null') {
          this[key] = data[key];
        } else {
          this[key] = null;
        }
      }
    }
    if (this.content.length){
      this.content = this.content.map(c => new Kpi(c))
    }
  }
}
